module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    attrs: {
      "id": "flows-index"
    }
  }, [_c('div', {
    staticClass: "header-with-action"
  }, [_c('h1', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.$t('flows.title.cadenceFlows')))]), (!_vm.current_user.isMonitoringManager()) ? _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "id": "new-flow",
      "to": "/fluxos-de-cadencia/opcoes-de-criacao"
    }
  }, [_c('span', {
    staticClass: "icon-more"
  }, [_vm._v("+")]), _vm._v(_vm._s(_vm.$t('flows.title.cadenceFlowNew')))]) : _vm._e(), _c('div', {
    staticClass: "clear"
  }), _c('list', {
    attrs: {
      "list_item_options": _vm.list_item_options
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32317f28!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/flows/index.vue
// module id = 1068
// module chunks = 1